import { WarningDiamondIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import { isBrowserTimezoneDataOutdated } from "common";
import React from "react";

export const OutdatedTimezoneData = () => {
    if (!isBrowserTimezoneDataOutdated()) {
        return null;
    }

    return (
        <Alert color="caution">
            <div className="mb-2 text-base font-bold">
                <WarningDiamondIcon /> Browser time zone data is out of date
            </div>
            Xola is correcting times automatically for now. Please update your browser to the latest version and restart
            it. On Safari, update macOS or iOS instead.
        </Alert>
    );
};
